import {
  RIB_CONFIG,
  type RibContext,
  type RibData,
  type RibExtraction,
} from "@asap/shared/document/document-types/rib";
import { RibSchemas } from "@asap/shared/schemas/document/document-types/rib";
import { formatFirstName, formatLastName } from "@asap/shared/utils/string";
import { DocumentTypeHandler } from "../handler";

export const RibHandler = new DocumentTypeHandler<RibExtraction, RibData, RibContext>({
  // Identity
  documentType: RIB_CONFIG.documentType,
  documentName: RIB_CONFIG.documentName,

  // Constraints
  maxFiles: RIB_CONFIG.maxFiles,
  acceptedMimeTypes: RIB_CONFIG.acceptedMimeTypes,
  requiredFields: RIB_CONFIG.requiredFields,

  // API endpoints
  endpoints: {
    extract: "documents/rib/extract",
    warn: "documents/rib/warn",
    verify: "documents/rib/verify",
    store: "documents/rib/store",
  },

  // Response schemas for runtime validation
  schemas: {
    extractResponse: RibSchemas.extractResponse,
    warnResponse: RibSchemas.warnResponse,
    validateResponse: RibSchemas.validateResponse,
    storeResponse: RibSchemas.storeResponse,
  },

  // Toast messages
  toastMessages: {
    success: "Le RIB a bien été validé.",
  },

  // Form fields
  formFields: [
    {
      key: "iban",
      label: RIB_CONFIG.fieldLabels.iban,
      type: "iban",
      placeholder: "Ex : FR76 3000 1007 9412 3456 7890 185",
    },
    {
      key: "bic",
      label: RIB_CONFIG.fieldLabels.bic,
      type: "text",
      placeholder: "Ex : BNPAFRPPXXX",
    },
    {
      key: "account_holder_last_name",
      label: RIB_CONFIG.fieldLabels.account_holder_last_name,
      type: "text",
      colSpan: 1,
    },
    {
      key: "account_holder_first_name",
      label: RIB_CONFIG.fieldLabels.account_holder_first_name,
      type: "text",
      colSpan: 1,
    },
  ],

  // Transform OCR extraction to form data
  transformExtraction: (extraction: RibExtraction): Partial<RibData> => {
    if (!extraction.isValidDocumentType) {
      throw new Error("Le fichier ajouté ne semble pas correspondre à un RIB. Vérifie que ce soit bien le cas.");
    }

    const result: Partial<RibData> = {};

    if (extraction.iban) result.iban = extraction.iban;
    if (extraction.bic) result.bic = extraction.bic;
    if (extraction.account_holder_last_name) {
      result.account_holder_last_name = formatLastName(extraction.account_holder_last_name);
    }
    if (extraction.account_holder_first_name) {
      result.account_holder_first_name = formatFirstName(extraction.account_holder_first_name);
    }

    return result;
  },
});
